import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var thumbsUpFilledIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  fill: "currentColor",
  viewBox: "0 0 16 15.94",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.34 6.92H.58a.59.59 0 0 0-.58.59v7.85a.58.58 0 0 0 .58.58h3.76Zm11.57 1.15a2.3 2.3 0 0 0-2.25-2h-3.15c.48-1.48.88-3.55 0-4.88A3 3 0 0 0 7.88 0a.58.58 0 0 0-.58.5 16.33 16.33 0 0 1-1.78 6.42s0 9 0 9h5.61c2.67 0 3.73-1.92 4.36-3.6a8.89 8.89 0 0 0 .42-4.25Z"
}));

export { thumbsUpFilledIcon as default };
//# sourceMappingURL=thumbsUpFilledIcon.js.map
